import { Coins } from 'lucide-react';

import { Button } from '@/components/atoms/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/molecules/dropdown-menu';
import { useConfigStore } from '@/lib/stores/config.store';
import type { Currency } from '@/lib/utils/constants';
import { useIsMounted } from '@/lib/hooks/use-is-mounted';

const HEADER_CURRENCIES: { value: Currency; label: string; flag: string }[] = [
  { value: 'EUR', label: 'Euro', flag: '🇪🇺' },
  { value: 'USD', label: 'Dollar américain', flag: '🇺🇸' },
  { value: 'KMF', label: 'Franc comorien', flag: '🇰🇲' },
];

export function CurrencySwitcher() {
  const { currency, setCurrency } = useConfigStore();
  const isMounted = useIsMounted();

  if (!isMounted) {
    return (
      <Button variant="ghost" size="sm" className="gap-1.5">
        <Coins className="size-4" />
        <span className="sr-only">Change currency</span>
      </Button>
    );
  }

  const current = HEADER_CURRENCIES.find((c) => c.value === currency);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="gap-1.5">
          <Coins className="size-4" />
          <span className="text-base leading-none">{current?.flag}</span>
          <span className="text-sm font-medium">{currency}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {HEADER_CURRENCIES.map((c) => (
          <DropdownMenuItem
            key={c.value}
            onClick={() => setCurrency(c.value)}
            className={c.value === currency ? 'bg-accent' : ''}
          >
            <span className="text-base leading-none mr-2">{c.flag}</span>
            {c.value} - {c.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
